import { render, staticRenderFns } from "./RecuperarClave.vue?vue&type=template&id=6c95376c&lang=pug"
import script from "./RecuperarClave.vue?vue&type=script&lang=js"
export * from "./RecuperarClave.vue?vue&type=script&lang=js"
import style0 from "./RecuperarClave.vue?vue&type=style&index=0&id=6c95376c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports